import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Imprint extends Component {
    render() {
        return (
            <div>
                <h1>Impressum</h1>
                <p>Angaben gemäß § 5 TMG</p>
                <p>
                    {this.props.owner}
                    <br />
                    {this.props.street}
                    <br />
                    {this.props.city}
                </p>
                <p>
                    <strong>Vertreten durch: </strong>
                    <br />
                    {this.props.owner}
                </p>
                <p>
                    <strong>Kontakt:</strong>
                    <br />
                    Telefon: {this.props.phone}
                    <br />
                    E-Mail: <a href={`mailto:info@${this.props.domain}`}>info@{this.props.domain}</a>
                </p>
                <p>
                    <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong>
                    <br />
                    {this.props.owner}
                    <br />
                    {this.props.street}
                    <br />
                    {this.props.city}
                </p>
                <p>
                    <strong>Haftungsausschluss: </strong>
                </p>
                <p>
                    <strong>Haftung für Inhalte</strong>
                </p>
                <p>
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
                    Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als
                    Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                    allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                    verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
                    zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder
                    Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
                    diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
                    Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
                    Inhalte umgehend entfernen.
                </p>
                <p>
                    <strong>Haftung für Links</strong>
                </p>
                <p>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss
                    haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
                    der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
                    verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                    Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
                    inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                    Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                    umgehend entfernen.
                </p>
                <p>
                    <strong>Urheberrecht</strong>
                </p>
                <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                    deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
                    außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors
                    bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
                    Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden
                    die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
                    Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                    entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
                    umgehend entfernen.
                </p>
                <p>
                    Impressum vom <a href="https://www.impressum-generator.de">Impressum Generator</a> der{' '}
                    <a href="https://www.kanzlei-hasselbach.de/">
                        Kanzlei Hasselbach, Rechtsanwälte für Arbeitsrecht und Familienrecht
                    </a>
                </p>
            </div>
        );
    }
}

Imprint.propTypes = {
    owner: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    domain: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired
};

export default Imprint;
